import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ECommentsActions } from '../../constants/actionTypes/comments';

export const setMainComment = actionGenerator<ECommentsActions.SET_MAIN_COMMENT, string>(
  ECommentsActions.SET_MAIN_COMMENT,
);

export type TSetMainCommentAction = ReturnType<typeof setMainComment>;

export type TCommentsActions = TSetMainCommentAction;
